document.addEventListener('DOMContentLoaded', function () {
  switchImage()
  watchDrawer()
  watchCartItems()
})

function switchImage() {
  // .cart-item for /cart
  // #cart-notification-product' for upper righr corner
  const rows = document.querySelectorAll('.cart-item')
  rows.forEach((row) => {
    if (!row.classList.contains('aos-animate')) {
      row.classList.add('aos-animate')
    }
    const image = row.querySelector('img')
    if (!image) {
      return
    }

    const dtNodes = row.querySelectorAll('dt')
    dtNodes.forEach((node) => {
      const text = node.textContent
      if (text === 'pacdora-image3D:') {
        const parentNode = node.parentNode
        const ddNode = parentNode.querySelector('dd')
        if (ddNode) {
          image.src = ddNode.textContent
        }

        parentNode.hidden = true
      }
    })
  })
}

/**
dynamic watch drawer, if drawer is visible, do switchimage
**/
// 使用MutationObserver监听drawer的可见性变化

function watchDrawer() {
  // .cart-notification for cart drawer
  // .cart-items for cart item in cart page
  const cartNotification = document.querySelector('.drawer')
  if (!cartNotification) {
    return
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
        const isVisible = cartNotification.classList.contains('active')
        if (isVisible) {
            switchImage()
          }
      }
    })
  })

  const config = { attributes: true, attributeFilter: ['style', 'class'] }
  observer.observe(cartNotification, config)
}

function watchCartItems() {
  // .cart-items for cart item in cart page
  const form = document.querySelector('#CartDrawer')
  if (!form) {
    return
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeName.toLowerCase() === 'cart-drawer-items') {
          switchImage()
          return
        }
      })
    })
  })

  const config = { childList: true, subtree: true }
  observer.observe(form, config)
}
